import { render } from "./genericCRUD_final.vue?vue&type=template&id=1f4d2784"
import script from "./genericCRUD_final.vue?vue&type=script&lang=js"
export * from "./genericCRUD_final.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__